import { ReactNode } from 'react';

import Text from '../base/Text';
import CrossIcon from '../icons/CrossIcon';
import Button from './Button';

export interface FeedbackNoticeAnswer {
  id: string;
  label: string;
  onSelect: () => void;
}

export interface FeedbackNoticeProps {
  question: string;
  answers: FeedbackNoticeAnswer[];
  belowAnswers?: ReactNode;
  onDismiss?: () => void;
  className?: string;
}

export default function FeedbackNotice({
  question,
  answers,
  belowAnswers,
  onDismiss,
  className,
}: FeedbackNoticeProps) {
  return (
    <div
      className={`shadow-menu border-gray-30 dark:border-gray-75 dark:bg-gray-90 pointer-events-auto w-[300px] max-w-[calc(100vw-2rem)] rounded-2xl border bg-white p-3 ${className ?? ''}`}
      data-state
    >
      <div className="mb-6 flex items-start gap-2">
        <Text
          as="div"
          variant="studio/body/sm"
          className="text-primary min-w-0 flex-1 text-pretty"
        >
          {question}
        </Text>
        <Button
          variant="tertiary"
          size="sm"
          onClick={onDismiss}
          className="text-secondary -mt-2.5 -mr-2.5"
          icon={<CrossIcon />}
        />
      </div>

      {answers.length > 0 ? (
        <div className="flex flex-col gap-2">
          {answers.map((answer) => (
            <Button
              key={answer.id}
              variant="secondary"
              onClick={answer.onSelect}
            >
              {answer.label}
            </Button>
          ))}
        </div>
      ) : null}
      {belowAnswers ? <div className="mt-3">{belowAnswers}</div> : null}
    </div>
  );
}
